import angular from 'angular'

// components
import manageAudioResources from './component/manageAudioResources.component.js'

export default angular
  .module('portalApp.manage.audioResources', [])
  .component('manageAudioResources', manageAudioResources)
  .name
